import React, { useState } from 'react'
import authorLoginStyle from './LoginPage.module.css'
import logo from '../assets/images/brandlogo.png'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaUserLarge } from "react-icons/fa6";
import { FaLock } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCoordinator } from '../redux/slices/coordinatorSlices';
import { Link } from 'react-router-dom';
import axios from "axios";
import Swal from "sweetalert2";
require('typeface-poppins')

export default function Login() {

  // Eye	
    const [isPasswordVisible, setPasswordVisible] = useState(false);	
    const togglePasswordVisibility = () => {
        setPasswordVisible(!isPasswordVisible);
    };

    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null); // To handle error messages
    const navigate = useNavigate();
  
    const handleSubmit = async (e) => {
        e.preventDefault();	

        setError(null); // Reset error message	

        const requestData = {
            email,
            password,
        };
       
        //	try {
          const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/centralized_login.php`, requestData);
    
        if (response.data.success==true) {
            const userId = response.data.user;
            const user_role= response.data.user_role;
            
            if(response.data.success==true){
                if(user_role=='Author'){
                    sessionStorage.setItem('authorToken', response.data.authorToken);
                    localStorage.setItem('author_user_id', response.data.user);
                    sessionStorage.setItem('isLoggedIn', 'true');
                    Swal.fire({
                    title: "Login Successful!",
                    text: "Redirecting to your profile...",
                    icon: "success",
                    timer: 2000, // Pop-up duration in milliseconds
                    showConfirmButton: false, // No need for a confirmation button
                    }).then(() => {
                        // Redirect after pop-up
                        navigate(`/AuthorEditPage/${userId}`);
                    });
                }
                else if(user_role=='Parent'){
                    Swal.fire({
                        title: "Thankyou for your submission",
                        text: "Thankyou for registering. Please check your email for login information.",
                        icon: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    }).then((data) => {
                        navigate(`/ParentsProfilePage/${userId}`);
                    });
                }
                else if(user_role=='Coordinator'){
                    // Store all necessary data
                    sessionStorage.setItem('coordinatorToken', response.data.coordinatorToken);
                    localStorage.setItem('cordinator_id', response.data.user);
                    localStorage.setItem('coordinatorEmail', response.data.email);
                    localStorage.setItem('coordinatorFName', response.data.f_name);
                    localStorage.setItem('coordinatorLName', response.data.l_name);
                    localStorage.setItem('coordinatorPosition', response.data.position);
                    localStorage.setItem('coordinatorPic', response.data.pic);
                    sessionStorage.setItem('isLoggedIn', 'true');
        
                    dispatch(setCoordinator({
                        id: response.data.user,
                        fName: response.data.f_name,
                        lName: response.data.l_name,
                        email: response.data.email,
                        position: response.data.position,
                        pic: response.data.pic,
                    }));
        
                    // Show success message
                    Swal.fire({
                        title: "Login Successful!",
                        text: "Redirecting to dashboard...",
                        icon: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    }).then(() => {
                        // Redirect to dashboard
                        navigate('/coordinator-dashboard', { replace: true });
                    });
                }
                else if(user_role=='Publisher'){
                    Swal.fire({
                        title: "Thankyou for your submission",
                        text: "Thankyou for login. Please check your email for login information.",
                        icon: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    }).then((data) => {
                        navigate(`/PublisherProfilePage/${userId}`);
                    });
                }
                else if(user_role=='Admin'){
                    sessionStorage.setItem('adminToken', response.data.authorToken);
                    localStorage.setItem('admin_user_id', response.data.user);
                    sessionStorage.setItem('isLoggedIn', 'true');
                    Swal.fire({
                        title: "Thankyou for your submission",
                        text: "Thankyou for login. Please check your email for login information.",
                        icon: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    }).then((data) => {
                        navigate(`/NewSchoolsOrganizationPage`);
                    });
                }
            } else if (response.data.success==false){
                //alert(response.data.message);
                Swal.fire({
                        title: "Thankyou for your submission",
                        text: "Thankyou for login. Please check your email for login information.",
                        icon: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
            } else{
                alert('User Id Required');
            }
        }
        else if(response.data.success==false){
                Swal.fire({
                        title: "Error!",
                        text: response.data.message,
                        icon: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
            }
            
    };

    const handleForgotPassword = async () => {

  // STEP 1: ENTER EMAIL
  const { value: email } = await Swal.fire({
    title: 'Forgot Password',
    input: 'email',
    inputLabel: 'Enter your registered email',
    inputPlaceholder: 'example@email.com',
    showCancelButton: true,
    confirmButtonText: 'Send OTP',
    inputValidator: (value) => {
      if (!value) return 'Email is required';
    }
  });

  if (!email) return;

  try {
    // SEND OTP API
    const sendOtpRes = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}authormeetapi/send_reset_otp.php`,
      { email }
    );

    if (!sendOtpRes.data.success) {
      Swal.fire('Error', sendOtpRes.data.message, 'error');
      return;
    }

    // STEP 2: VERIFY OTP & NEW PASSWORD
    const { value: resetData } = await Swal.fire({
      title: 'Reset Password',
      html: `
        <input id="otp" class="swal2-input" placeholder="Enter 6-digit OTP">
        <input id="newPassword" type="password" class="swal2-input" placeholder="New Password">
        <input id="confirmPassword" type="password" class="swal2-input" placeholder="Confirm Password">
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Reset Password',
      preConfirm: () => {
        const otp = document.getElementById('otp').value;
        const newPassword = document.getElementById('newPassword').value;
        const confirmPassword = document.getElementById('confirmPassword').value;

        if (!otp || otp.length !== 6) {
          Swal.showValidationMessage('Enter valid 6-digit OTP');
          return false;
        }

        if (!newPassword || newPassword.length < 6) {
          Swal.showValidationMessage('Password must be at least 6 characters');
          return false;
        }

        if (newPassword !== confirmPassword) {
          Swal.showValidationMessage('Passwords do not match');
          return false;
        }

        return { email, otp, newPassword };
      }
    });

    if (!resetData) return;

    // RESET PASSWORD API
    const resetRes = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}authormeetapi/reset_password.php`,
      resetData
    );

    if (resetRes.data.success) {
      Swal.fire({
        title: 'Success!',
        text: 'Password reset successfully. You can now login.',
        icon: 'success',
      });
    } else {
      Swal.fire('Error', resetRes.data.message, 'error');
    }

  } catch (error) {
    console.error(error);
    Swal.fire('Error', 'Something went wrong', 'error');
  }
};


  return (
    <>
    <div className={authorLoginStyle.authincationMain}>
        <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center">
                <div className="col-md-6">
                    <div className={authorLoginStyle.authincationContent}>
                        <div className="row no-gutters">
                            <div className="col-xl-12">
                                <div className={authorLoginStyle.authForm}>
                                    <div className="text-center mb-3">
                                        <a href="https://www.authormeet.net/" className={authorLoginStyle.brandLink}>
                                        <img src={logo} alt="BrandLogo" />
                                        <div className={authorLoginStyle.brandInfo}>
                                            <span> AuthorMeet </span>
                                            <small> Powered by: &nbsp; Bookworm Central </small>
                                        </div>
                                        </a>
                                    </div>
                                    <h4 className={authorLoginStyle.brandTitle}> Sign in </h4>
                                    <form onSubmit={handleSubmit}>
                                        <div className={`${authorLoginStyle.inputIconboxes} input-group mb-4`}>
                                            <span className={`${authorLoginStyle.inputIcon} input-group-text`}>
                                                <FaUserLarge className={authorLoginStyle.primaryColor} />
                                            </span>
                                            <input type="email" value={email} className={`${authorLoginStyle.inputFeild} form-control`} placeholder="Email Address" onChange={(e) => setEmail(e.target.value)} required />
                                        </div>
                                        <div className={`${authorLoginStyle.inputIconboxes} input-group mb-3`}>
                                            <span className={`${authorLoginStyle.inputIcon} input-group-text`}>
                                                <FaLock className={authorLoginStyle.primaryColor} />
                                            </span>
                                            <input type={isPasswordVisible ? "text" : "password"} className={`${authorLoginStyle.inputFeild} form-control`} placeholder="Password" onChange={(e) => setPassword(e.target.value)} required />
                                            <div className={authorLoginStyle.toggleButton} onClick={togglePasswordVisibility}>
                                                {isPasswordVisible ? <FaEyeSlash className={authorLoginStyle.eyeIcon} /> : <FaEye className={authorLoginStyle.eyeIcon} />}
                                            </div>	
                                        </div>
                                        <div className={`${authorLoginStyle.forgotPassword} form-group text-center mb-3`}>
                                            <a href="#" onClick={handleForgotPassword} > Forgot Password? </a>
                                        </div>
                                        <div className="form-row d-flex justify-content-between mt-3 mb-3 d-none d-lg-block">
                                            <div className="form-group">
                                                <div className="custom-control custom-checkbox ml-1">
                                                    <input type="checkbox" className="custom-control-input me-2" id="" />
                                                    <label className={`${authorLoginStyle.rememberMe} custom-control-label`}> Remember me </label>
                                                </div>
                                            </div>																									
                                        </div>
                                        <div className="text-center">
                                            {error && <p style={{ color: 'red' }}>{error}</p>}
                                            <button type="submit" className={`${authorLoginStyle.authorSigninBtn} btn btn-warning`}>Login</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>	
    </>
  )
}
